import { AuthValidator } from "@/domain/entities-new/user/user.validations";
import {
  AuthEmailVerificationError,
  AuthInvalidCredentialsError,
  AuthLoginError,
  AuthLogoutError,
  AuthNotFoundError,
  AuthRegistrationError,
  AuthSessionNotFoundError,
} from "@/domain/errors/auth";
import { IAuthRepository } from "@/domain/repositories/auth.repository";
import { AuthTokens } from "@/domain/value-objects/auth";
import APIClient, { CleanAPIClient } from "@/infrastructure/api/client";
import { repositoryErrorHandler } from "@/infrastructure/repositories/common/repository-error-handler";
import { AuthRepositoryErrorHandler } from "./auth-repository-error.handler";

const AuthApiRepository: IAuthRepository = {
  async login(credentials) {
    try {
      const response = await CleanAPIClient.post<AuthTokens>(
        "/auth/login/",
        credentials
      );
      return AuthValidator.AuthTokens.fromAPI(response.data);
    } catch (error) {
      throw repositoryErrorHandler(
        error,
        new AuthLoginError(),
        new AuthInvalidCredentialsError(),
        AuthRepositoryErrorHandler.Login
      );
    }
  },

  async logout() {
    try {
      await APIClient.post("/auth/logout/");
    } catch (error) {
      throw repositoryErrorHandler(
        error,
        new AuthLogoutError(),
        new AuthSessionNotFoundError()
      );
    }
  },

  async register(data) {
    try {
      await APIClient.post("/users/registrations/", data);
    } catch (error) {
      throw repositoryErrorHandler(
        error,
        new AuthRegistrationError(),
        new AuthNotFoundError(),
        AuthRepositoryErrorHandler.Register
      );
    }
  },

  async verifyEmail(data) {
    try {
      await APIClient.post("/users/registrations/email-verifications/", data);
    } catch (error) {
      throw repositoryErrorHandler(
        error,
        new AuthEmailVerificationError(),
        new AuthNotFoundError(),
        AuthRepositoryErrorHandler.VerifyEmail
      );
    }
  },

  async resetVerificationEmail(email: string) {
    try {
      await APIClient.post("/users/registrations/email-verifications/reset/", {
        email,
      });
    } catch (error) {
      throw repositoryErrorHandler(
        error,
        new AuthEmailVerificationError(),
        new AuthNotFoundError(),
        AuthRepositoryErrorHandler.ResetVerifyEmail
      );
    }
  }
};

export { AuthApiRepository };
